import styled from 'styled-components';
import { StyledButton } from '../../globalStyled';

export const BidSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledBidButton = styled(StyledButton)`
  padding: 7px 10px;
  min-width: 30px;
`;

export const StyledInput = styled.input`
  appearance: textfield;
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
    display: none;
  }
  width: 80px;
  position: relative;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.border};
  background-color: ${({ theme }) => theme.inset};
  color: ${({ theme }) => theme.text};
  font-family: Archivo;
  font-size: 45px;
  font-weight: bold;
  font-stretch: normal;
  padding: 13px;
  margin: 0 35px;
  text-align: center;
`;
